interface GenericApiResponse<T> {
  body: T;
  message?: string;
  status: number;
  [key: string]: any;
}

interface RequestOptions extends RequestInit {
  headers?: { [key: string]: string };
}

export class ApiError extends Error {
  errorType: string;
  message: string;
  status: number;

  constructor(message: string, status: number, errorType?: string) {
    super(message);
    this.message = message;
    this.status = status;
    this.errorType = errorType ?? 'API_ERROR';
  }
}

export const post = async <Request, Response>(
  url: string,
  data: Request,
  options: RequestOptions = {}
): Promise<GenericApiResponse<Response>> => {
  try {
    console.log("url", url);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept':  'application/json',
        ...options.headers,
      },
      body: JSON.stringify(data),
      ...options,
    });

    const result: GenericApiResponse<Response> = {
      status: response.status,
      message: '',
      body: {} as Response,
    };

    if (!response.ok) {
      const errorText = await response.text();
      result.message = `Error: ${response.statusText} - ${errorText}`;
      console.error(`HTTP Error: ${response.statusText}, ${errorText}`);
      return result;
    }

    result.body = await response.json();
    return result;

  } catch (error) {
    console.error('Error in postRequest:', error);

    return {
      body: {} as Response,
      status: 500,
      message: 'An unexpected error occurred.',
    };
  }
};
